import { Component } from '@angular/core';

@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent {
  constructor() {
    window.location.href = '/';
  }
}



// WEBPACK FOOTER //
// ./client/app/dashboard/dashboard.component.ts